import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export const PageScrollProgressBar = ({ className }: { className?: string }) => {
  const [scrollDistance, setScrollDistance] = useState(0);

  const getDocHeight = () =>
    Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.body.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight,
      document.documentElement.clientHeight,
    );

  const calculateScrollDistance = (): void => {
    const scrollTop = window.pageYOffset; // how much the user has scrolled by
    const winHeight = window.innerHeight;
    const docHeight = getDocHeight();

    const totalDocScrollLength = docHeight - winHeight;
    setScrollDistance(scrollTop / totalDocScrollLength);
  };

  const handleScroll = (): void => {
    requestAnimationFrame(() => {
      calculateScrollDistance();
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      aria-hidden={scrollDistance > 0 ? false : true}
      className={twMerge(
        clsx(
          'pointer-events-none fixed left-0 z-nav h-3 w-full origin-[0] bg-secondary-300 transition-transform duration-[0.12s] ease-in-out light:bg-secondary-75',
          className,
        ),
      )}
      style={{
        transform: `scaleX(${scrollDistance})`,
      }}
    />
  );
};
